/* eslint-disable */
export const BOX_SIZE = 82;

export const getMathProps = (from = {}, to = {}) => {
  const initial_x = from.x;
  const initial_y = from.y;

  const dx = initial_x - to.x;
  const dy = initial_y - to.y;
  const angle = Math.atan2(dx, dy);
  const distance = Math.sqrt(dx * dx + dy * dy);

  return {
    angle,
    distance,
    from,
    to,
    computed: {
      x: Math.sin(angle),
      y: Math.cos(angle)
    }
  };
};

export const transform2Coords = CSStransform => {
  const m = new WebKitCSSMatrix(CSStransform);
  return {
    x: m.m41,
    y: m.m42
  };
};

export const getCenterBox = box => {
  return {
    x: box.x + BOX_SIZE / 2,
    y: box.y + BOX_SIZE / 2
  };
};

export const getConnectors = (from = {}, to = {}) => {
  const props = getMathProps(from, to);

  return {
    from: {
      x: props.from.x - props.computed.x * (BOX_SIZE / 2 - 2),
      y: props.from.y - props.computed.y * (BOX_SIZE / 2 - 2)
    },

    to: {
      x: props.to.x + props.computed.x * (BOX_SIZE / 2 - 2),
      y: props.to.y + props.computed.y * (BOX_SIZE / 2 - 2)
    }
  };
};

export const getMarkers = (from = {}, to = {}, markers = []) => {
  const dx = from.x - to.x;
  const dy = from.y - to.y;

  const D = Math.sqrt(dx * dx + dy * dy);

  const n = markers.length;
  let d = D / (n + 1);

  if (d > 30) {
    d = 30;
  }

  const d1 = D / 2 - ((n - 1) * d) / 2;

  const angle = Math.atan2(dx, dy);

  return markers.map((item, index) => {
    return {
      x: from.x + -((d1 + d * index) * Math.sin(angle)) - 13,
      y: from.y + -((d1 + d * index) * Math.cos(angle)) - 13,
      name: item,
      type: from.type
    };
  });
};

// reactive box layout update
export const updateBoxLayout = (boxLayout, data) => {
  return {
    ...boxLayout,
    ...data
  };
};

// reactive box position update
export const updateBoxPosition = (boxLayout, data) => {
  return updateBoxLayout(boxLayout, {
    position: {
      ...boxLayout.position,
      ...data
    }
  });
};

// check if 2 positions are colliding
export const positionsAreColliding = (positionA, positionB) => {
  const offset = 30;
  return (
    positionA.x < positionB.x + BOX_SIZE + offset &&
    positionA.x + BOX_SIZE + offset > positionB.x &&
    positionA.y < positionB.y + BOX_SIZE + offset &&
    positionA.y + BOX_SIZE + offset > positionB.y
  );
};

export const circlePositionsAreColliding = (positionA, positionB) => {
  const safe = 80;
  let d = 0;

  const init_x = positionB.x;
  const init_y = positionB.y;

  const drag_x = positionA.x;
  const drag_y = positionA.y;

  const dx = init_x - drag_x;
  const dy = init_y - drag_y;
  const ra = Math.atan2(dx, dy);
  const distance = Math.sqrt(dx * dx + dy * dy);

  if (distance < safe) {
    d = safe - distance;
  } else {
    d = 0;
  }

  return !d;
};

export const getColliding = (layout, position) => {
  for (let i = 0; i < layout.length; i++) {
    if (positionsAreColliding(layout[i].position, position)) {
      return layout[i];
    }
  }
  return null;
};

export const getCollidings = (layout, position) => {
  let result = [];
  for (let i = 0; i < layout.length; i++) {
    if (circlePositionsAreColliding(layout[i].position, position)) {
      result.push(layout[i]);
    }
  }
  return result;
};

// check if position is free in layout
export const isFree = (layout, position) => {
  for (let i = 0; i < layout.length; i++) {
    if (positionsAreColliding(layout[i].position, position)) {
      return false;
    }
  }
  return true;
};

export const isCircleFree = (layout, position) => {
  for (let i = 0; i < layout.length; i++) {
    if (circlePositionsAreColliding(layout[i].position, position)) {
      return false;
    }
  }
  return true;
};

export const moveBox = (dragging, target) => {
  const safe = 80;
  let d = 0;

  const init_x = target.position.x;
  const init_y = target.position.y;

  const drag_x = dragging.position.x;
  const drag_y = dragging.position.y;

  const dx = init_x - drag_x;
  const dy = init_y - drag_y;
  const ra = Math.atan2(dx, dy);
  const distance = Math.sqrt(dx * dx + dy * dy);

  if (distance < safe) {
    d = safe - distance;
  } else {
    d = 0;
  }

  if (d > 0) {
    const x = init_x + Math.sin(ra) * d;
    const y = init_y + Math.cos(ra) * d;

    target = updateBoxPosition(target, {
      x: x,
      y: y
    });
  }

  return target;
};

// updates box position to a free place in a given layout
export const moveBoxToFreePlace = (layout, boxLayout) => {
  while (!isFree(layout, boxLayout.position)) {
    const dragging = getColliding(layout, boxLayout.position);

    var safe = 80;
    var d = 0;

    var pos = dragging.position;
    var initial_x = boxLayout.position.x;
    var initial_y = boxLayout.position.y;

    var cx = pos.x;
    var cy = pos.y;

    var dx = initial_x - cx;
    var dy = initial_y - cy;

    var ra = Math.atan2(dx, dy);

    var distance = Math.sqrt(dx * dx + dy * dy);

    if (distance < safe) {
      d = safe - distance;
    } else {
      d = 0;
    }

    var l = initial_x + Math.sin(ra) * d;
    var t = initial_y + Math.cos(ra) * d;

    boxLayout = updateBoxPosition(boxLayout, {
      x: l,
      y: t
    });
  }
  return boxLayout;
};

// sort layout based on position and visibility
export const sortLayout = layout => {
  return [...layout].sort((a, b) => {
    if (a.position.y < b.position.y) {
      return -1;
    }
    if (a.position.y > b.position.y) {
      return 1;
    }
    if (a.position.x < b.position.x) {
      return -1;
    }
    if (a.position.x > b.position.x) {
      return 1;
    }
    return 0;
  });
};

// get box position in pixels
export const positionToPixels = position => {
  return {
    x: position.x,
    y: position.y,
    w: BOX_SIZE,
    h: BOX_SIZE
  };
};

// get layout bounding box
export const getLayoutSize = layout => {
  return {
    w: layout.reduce((width, boxLayout) => {
      return boxLayout.hidden ? width : Math.max(width, boxLayout.position.x + BOX_SIZE);
    }, 0),
    h: layout.reduce((height, boxLayout) => {
      return boxLayout.hidden ? height : Math.max(height, boxLayout.position.y + BOX_SIZE);
    }, 0)
  };
};

// check if element matches a selector
// https://davidwalsh.name/element-matches-selector
export const matchesSelector = (el, selector) => {
  var p = Element.prototype;
  var f =
    p.matches ||
    p.webkitMatchesSelector ||
    p.mozMatchesSelector ||
    p.msMatchesSelector ||
    function(s) {
      return [].indexOf.call(document.querySelectorAll(s), this) !== -1;
    };
  return f.call(el, selector);
};

// check if layout has collisions
export const layoutHasCollisions = layout => {
  for (let i = 0; i < layout.length; i++) {
    for (let j = i + 1; j < layout.length; j++) {
      if (positionsAreColliding(layout[i].position, layout[j].position)) {
        return true;
      }
    }
  }
  return false;
};

// fix layout with collisions
export const fixLayout = layout => {
  layout = sortLayout(layout);
  let fixedLayout = [];
  layout.forEach(boxLayout => {
    fixedLayout.push(moveBoxToFreePlace(fixedLayout, boxLayout));
  });
  return fixedLayout;
};
